module.exports = __webpack_public_path__ + "media/offers/ring-1-55711753.png";